<template>
  <v-container class="mt-3">
    <v-card>
      <v-card-title
        ><h1 class="text-h6 font-weight-bold ma-0">
          Google Resume Guide: How to Write a Resume Google Recruiters Notice
        </h1></v-card-title
      >
      <v-card-text>
        <resume-cta-banner />
        <v-row>
          <v-col cols="12">
            Google's hiring process is built around a hiring committee that
            reviews your application after a recruiter and interviewers have
            already weighed in — which means your resume needs to hold up to
            more than one reader, not just get you past a first-pass filter.
            Here's what tends to move the needle.
          </v-col>
        </v-row>

        <h2 class="text-h6 mt-4 mb-2">1. Use Google's Own "XYZ" Formula</h2>
        <p>
          Google recruiters have publicly recommended structuring bullet points
          as:
          <em>"Accomplished [X] as measured by [Y], by doing [Z]."</em>
          For example: "Reduced page load time by 40% (Y), as measured by
          Lighthouse scores, by rewriting the image pipeline to use lazy loading
          (Z)." This format forces you to include both the result and the
          mechanism, which is exactly what reviewers are scanning for.
        </p>

        <h2 class="text-h6 mt-4 mb-2">2. Emphasize Scale and Ambiguity</h2>
        <p>
          Google's hiring committees calibrate level in part by how much
          ambiguity and scale you've handled. Mention when you worked with large
          datasets, high-traffic systems, cross-team dependencies, or had to
          define the problem yourself rather than being handed a fully-scoped
          task.
        </p>

        <h2 class="text-h6 mt-4 mb-2">
          3. Show "Googleyness" Through Actions, Not Adjectives
        </h2>
        <p>
          Don't write "collaborative" or "innovative" as standalone traits.
          Instead show it: "Proposed and led a cross-team design review that
          consolidated three overlapping internal tools into one, adopted by 40+
          engineers." Committees look for evidence, not self-description.
        </p>

        <h2 class="text-h6 mt-4 mb-2">
          4. Technical Roles: Lead With Systems, Not Just Languages
        </h2>
        <p>
          Listing "Python, Java, Go" is table stakes. What differentiates
          candidates is what you built with them — the system design decisions,
          trade-offs, and the scale at which the system ran.
        </p>

        <h2 class="text-h6 mt-4 mb-2">
          5. Keep It to One or Two Pages, Reverse-Chronological
        </h2>
        <p>
          Google recruiters skim fast in an early pass. A clean,
          reverse-chronological resume in a standard format, one to two pages
          depending on seniority, is easier to evaluate than a creative layout.
        </p>

        <h2 class="text-h6 mt-4 mb-2">
          6. Tailor Your Summary to the Team, Not Just "Google"
        </h2>
        <p>
          Google spans Search, Cloud, YouTube, Android, and dozens of other orgs
          with different priorities. If you know which team or org you're
          targeting, mirror the language from that specific job posting rather
          than a generic "Google" pitch.
        </p>

        <v-alert type="info" outlined class="mt-4">
          Tip: If you're also considering other top tech employers, our
          <router-link to="/faang-resume-guide">FAANG resume guide</router-link>
          covers the patterns that hold across companies, and our
          <router-link to="/meta-resume-guide">Meta</router-link>
          and
          <router-link to="/amazon-resume-guide">Amazon</router-link>
          guides cover what those companies specifically emphasize.
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ResumeCtaBanner from "../../components/ResumeCtaBanner.vue";

export default {
  name: "GoogleResumeGuide",
  components: { ResumeCtaBanner },
  mounted() {
    this.$utils.visit(this);
  },
};
</script>
